export enum JobPartNoteType {
  DEFAULT = 'default',
  ELEMENT = 'element',
}
